import { contexts } from '@/domains'
import useFormatData from '@/domains/hooks/useFormatData'
import { Breadcrumb, Card } from 'antd'
import sortBy from 'lodash/sortBy'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect } from 'react'
import Filter from './components/Filter'
import List from './components/List'
import SiteBreadcrumb from '@/components/SiteBreadcrumb'
import { useParams } from 'react-router-dom'; 
import { globalStore, load } from '@/common/index'

const { BugContext, GlobalContext, UserContext } = contexts
const BUG_STATUS_DONE = '已完成'
let timer
const Bug = () => {
  const { onlyFridayAvailable } = useFormatData()
  const {
    currentDate,
    handleDateChange,
    getList,
    list,
    deliveryMap,
    getDeliveryList,
    statusList
  } = BugContext.useContainer()
  const { userRecord } = UserContext.useContainer()
  const { userInfo: gUserInfo } = GlobalContext.useContainer()
  const store = useLocalObservable(() => ({
    visualMode: 'bug',
    onlyNotFix: false,
    onlyMyReport: false,
    sortField: 'follower',
    isAsc: true,
    innerList: [],
    userList: []
  }))
  useEffect(() => {
    getList()
    getDeliveryList()
    if(!globalStore.currentUser){
      load();
    }
  }, [])

  useEffect(() => {
    let _list = list
    if (store.onlyNotFix) {
      const doneStatusIds = new Set(
        statusList
          .filter((s) => s.name === BUG_STATUS_DONE)
          .map((s) => s.status)
      )
      _list = _list.filter((item) => !doneStatusIds.has(item.status))
    }
    if (store.userList.length) {
      const userListMap = {}
      store.userList.forEach((item) => (userListMap[item] = true))
      _list = _list.filter((item) => {
        return item.userList.some((i) => userListMap[i.id])
      })
    }
    if (store.onlyMyReport) {
      _list = _list.filter((item) => item.fromUser == gUserInfo.id)
    }
    _list = sortBy(_list, (item) => {
      switch (store.sortField) {
        case 'follower':
          return item.userList[0]?.userNamePinyin
        case 'reporter':
          return userRecord[item.fromUser]?.userNamePinyin
        case 'status':
          return item.status
        case 'task':
          return deliveryMap[item.taskId]?.taskName
      }
    })
    if (!store.isAsc) {
      _list = _list.reverse()
    }
    store.innerList = _list
  }, [
    list,
    statusList,
    store.onlyNotFix,
    store.userList,
    store.onlyMyReport,
    store.sortField,
    store.isAsc
  ])
  useEffect(() => {
    timer = setInterval(() => {
      if (!document.hidden) {
        getList()
      }
    }, 5 * 1000)
    return () => {
      clearInterval(timer)
    }
  })


  

  return (
    <div className="w-full flex flex-col">
      <SiteBreadcrumb name="缺陷管理" />
      <Card>
        <Filter store={store}></Filter>
        <List list={store.innerList}></List>
      </Card>
    </div>
  )
}

export default observer(Bug)
